import { render, staticRenderFns } from "./documentCompassCollect.vue?vue&type=template&id=47e3e58a&scoped=true&"
import script from "./documentCompassCollect.vue?vue&type=script&lang=js&"
export * from "./documentCompassCollect.vue?vue&type=script&lang=js&"
import style0 from "./documentCompassCollect.vue?vue&type=style&index=0&id=47e3e58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3e58a",
  null
  
)

export default component.exports